import { http } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-拆迁点位-列表
 */
export function API_POINT_LIST(data?: BasicPageReq) {
  return http.post<ApiPoint.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-拆迁点位-全部
 */
export function API_POINT_ALL(data?: BasicPageReq) {
  return http.post<ApiPoint.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-拆迁点位-详情
 */
export function API_POINT_DETAIL(id: string) {
  return http.post<ApiPoint.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-拆迁点位-新增
 */
export function API_POINT_ADD(data: ApiPoint.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-拆迁点位-删除
 */
export function API_POINT_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-拆迁点位-编辑
 */
export function API_POINT_EDIT(data: BasicUpdateOneReq<ApiPoint.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-拆迁点位-禁用
 */
export function API_POINT_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-拆迁点位-启用
 */
export function API_POINT_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-拆迁点位-排序
 */
export function API_POINT_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}
